import React, { Fragment } from 'react';

var FilterLayout = function FilterLayout(_ref) {
  var filters = _ref.filters,
      validFilters = _ref.validFilters,
      onSearch = _ref.onSearch,
      columnSet = _ref.columnSet,
      loading = _ref.loading,
      initializing = _ref.initializing;
  return /*#__PURE__*/React.createElement("form", {
    onSubmit: onSearch
  }, filters.filter(function (_filter, name) {
    return columnSet.includes(name);
  }).map(function (filter, name) {
    return /*#__PURE__*/React.createElement(Fragment, {
      key: name
    }, filter);
  }).toIndexedSeq().toList(), /*#__PURE__*/React.createElement("button", {
    type: "submit"
  }, "Search"));
};

export default FilterLayout;